"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return EyeOff;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function EyeOff(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        d: "M1.50028 1.5L4.49125 4.49097M16.5003 16.5L13.5096 13.5093M10.5627 14.6872C10.0567 14.7831 9.53455 14.8333 9.00067 14.8333C5.26929 14.8333 2.11071 12.3809 1.04883 8.99997C1.33791 8.07958 1.78237 7.22801 2.35148 6.47598M7.23252 7.23223C7.68493 6.77982 8.30993 6.5 9.00028 6.5C10.381 6.5 11.5003 7.61929 11.5003 9C11.5003 9.69036 11.2205 10.3154 10.7681 10.7678M7.23252 7.23223L10.7681 10.7678M7.23252 7.23223L4.49125 4.49097M10.7681 10.7678L4.49125 4.49097M10.7681 10.7678L13.5096 13.5093M4.49125 4.49097C5.7911 3.65295 7.33909 3.16667 9.00065 3.16667C12.732 3.16667 15.8906 5.61909 16.9525 9.00003C16.3634 10.8756 15.129 12.4654 13.5096 13.5093",
        stroke: "#96A6A5",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
}

//# sourceMappingURL=EyeOff.js.map